import { Heading } from '@lili/lili-frontend-common';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as ActiveLinkIcon } from '@Assets/icons/menu-active-link.svg';
import { ReactComponent as CheckmarkIcon } from '@Assets/icons/checkmark-adaptive.svg';

interface DesktopSideBarItemProps {
  routeName: string;
  isActive: boolean;
  isPrevious: boolean;
}

export const DesktopSideBarItem = ({
  routeName,
  isActive,
  isPrevious,
}: DesktopSideBarItemProps) => {
  return (
    <li key={routeName}>
      <div className='flex items-center gap-[8px] p-[8px]'>
        {isPrevious && <CheckmarkIcon className='w-[24px] object-cover text-text-main-disabled' />}
        {isActive && <ActiveLinkIcon className='w-[24px] text-text-main-primary-inverse' />}
        <Heading.H8
          className={twMerge(
            isActive && 'text-text-main-primary-inverse',
            isPrevious && 'text-text-main-disabled',
            !isPrevious && !isActive && 'text-text-main-tertiary-inverse'
          )}>
          {routeName}
        </Heading.H8>
      </div>
    </li>
  );
};
